"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchPlayerRole = void 0;
var MatchPlayerRole;
(function (MatchPlayerRole) {
    /**
     * Match creator
     */
    MatchPlayerRole["Owner"] = "owner";
    /**
     * Match player
     */
    MatchPlayerRole["Player"] = "player";
})(MatchPlayerRole = exports.MatchPlayerRole || (exports.MatchPlayerRole = {}));
//# sourceMappingURL=match-player-role.js.map